import { render, staticRenderFns } from "./feijiaoplan.vue?vue&type=template&id=2837bc45&scoped=true&"
import script from "./feijiaoplan.vue?vue&type=script&lang=js&"
export * from "./feijiaoplan.vue?vue&type=script&lang=js&"
import style0 from "./feijiaoplan.vue?vue&type=style&index=0&id=2837bc45&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2837bc45",
  null
  
)

export default component.exports